import { KeywordTrackingRouteConfig } from '@/modules/seo/keywordtracking/KeywordTrackingRouteConfig';
import { ENABLE_CLIENT, WebsiteRouteNames } from '@/modules/seo/website/website.constants';
import { KeywordTrackingTab } from '@/modules/seo/keywordtracking/keywordtracking.constants';

export const router = KeywordTrackingRouteConfig.factory([
  {
    path: '/raven/websites/:id(\\d+)/keywordtracking',
    redirect: `/raven/websites/:id(\\d+)/keywordtracking/${KeywordTrackingTab.OVERVIEW}`,
  },
  {
    path: '/raven/websites/:id(\\d+)/keywordtracking/:keywordTrackingTab',
    name: WebsiteRouteNames.KEYWORD_TRACKING,
    component: () => {
      if (ENABLE_CLIENT) {
        return import(
          /* webpackChunkName: "website-inner-page-with-client" */ '../website/pages/WebsiteInnerPageWithClient.vue'
        );
      }
      return import(
        /* webpackChunkName: "website-inner-page" */ '../website/pages/WebsiteInnerPage.vue'
      );
    },
    props: true,
  },
]);
